import { render, staticRenderFns } from "./DisCount.vue?vue&type=template&id=5da1baa4&scoped=true&"
import script from "./DisCount.vue?vue&type=script&lang=js&"
export * from "./DisCount.vue?vue&type=script&lang=js&"
import style0 from "./DisCount.vue?vue&type=style&index=0&id=5da1baa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da1baa4",
  null
  
)

export default component.exports